const NewJobsTabDesktopIcon = () => (
	<svg
		width={40}
		height={40}
		viewBox="0 0 40 40"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g clipPath="url(#clip0_20485_87466)">
			<path
				d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
				fill="white"
			/>
			<rect
				x={9.5}
				y={9.97461}
				width={15.5501}
				height={19.9591}
				rx={0.882585}
				fill="#E8E7EA"
				stroke="#190A28"
				strokeWidth={0.933333}
			/>
			<path
				d="M11.8333 22.334H22.3333"
				stroke="#190A28"
				strokeWidth={1.16667}
				strokeLinecap="round"
			/>
			<path
				d="M11.8333 18.834H22.3333"
				stroke="#190A28"
				strokeWidth={1.16667}
				strokeLinecap="round"
			/>
			<path
				d="M11.8333 25.834H22.3333"
				stroke="#190A28"
				strokeWidth={1.16667}
				strokeLinecap="round"
			/>
			<rect
				x={20}
				y={25.6006}
				width={11.2}
				height={7.46667}
				rx={1.19399}
				fill="#E8E7EA"
				stroke="#190A28"
				strokeWidth={0.933333}
			/>
			<path
				d="M20 25.7956C20 25.1728 20.5049 24.668 21.1277 24.668H30.0723C30.6951 24.668 31.2 25.1728 31.2 25.7956V28.2355C31.2 28.7088 30.9054 29.131 30.455 29.2766C29.3298 29.6404 27.1626 30.268 25.6 30.268C24.0374 30.268 21.8702 29.6404 20.745 29.2766C20.2946 29.131 20 28.7088 20 28.2355V25.7956Z"
				fill="#E8E7EA"
				stroke="#190A28"
				strokeWidth={0.933333}
			/>
			<path
				d="M27.4667 24.6674V23.8721C27.4667 23.2804 26.9871 22.8008 26.3955 22.8008H24.8047C24.213 22.8008 23.7334 23.2804 23.7334 23.8721V24.6674"
				stroke="#190A28"
				strokeWidth={0.933333}
			/>
			<path
				d="M24.6667 29.5595C24.6667 29.435 24.7677 29.334 24.8923 29.334H26.3079C26.4324 29.334 26.5334 29.435 26.5334 29.5595V30.9751C26.5334 31.0997 26.4324 31.2007 26.3079 31.2007H24.8923C24.7677 31.2007 24.6667 31.0997 24.6667 30.9751V29.5595Z"
				fill="#E8E7EA"
				stroke="#190A28"
				strokeWidth={0.933333}
			/>
			<path
				d="M21.6563 13H22.3806C22.4422 13 22.4859 13.0146 22.5119 13.0438C22.541 13.0697 22.5556 13.1134 22.5556 13.175V15.0611C22.5556 15.1648 22.5508 15.262 22.541 15.3528C22.5346 15.4403 22.5102 15.544 22.4681 15.6639L22.2251 16.325C22.2089 16.3736 22.1846 16.4157 22.1521 16.4514C22.123 16.4838 22.0825 16.5 22.0306 16.5H21.3841C21.3322 16.5 21.2852 16.4887 21.2431 16.466C21.201 16.4433 21.1734 16.406 21.1605 16.3542L20.9369 15.5618C20.9271 15.5294 20.9142 15.5083 20.898 15.4986C20.885 15.4856 20.8688 15.4792 20.8494 15.4792H20.8056C20.7862 15.4792 20.7683 15.4856 20.7521 15.4986C20.7392 15.5083 20.7278 15.5294 20.7181 15.5618L20.4896 16.3542C20.4767 16.4028 20.4524 16.44 20.4167 16.466C20.3811 16.4887 20.3373 16.5 20.2855 16.5H19.6438C19.592 16.5 19.5466 16.4838 19.5077 16.4514C19.4721 16.419 19.4461 16.3769 19.4299 16.325L19.1869 15.6542C19.1447 15.5343 19.1188 15.4306 19.1091 15.3431C19.1026 15.2523 19.0994 15.1551 19.0994 15.0514V13.175C19.0994 13.1134 19.1123 13.0697 19.1383 13.0438C19.1674 13.0146 19.2128 13 19.2744 13H20.023C20.0846 13 20.1283 13.0146 20.1542 13.0438C20.1834 13.0697 20.198 13.1134 20.198 13.175V14.9639L20.4799 14.3514C20.5058 14.2963 20.5399 14.2574 20.582 14.2347C20.6241 14.212 20.676 14.2007 20.7376 14.2007H20.9417C21.0033 14.2007 21.0552 14.212 21.0973 14.2347C21.1394 14.2574 21.1734 14.2963 21.1994 14.3514L21.4813 14.9639V13.175C21.4813 13.1134 21.4943 13.0697 21.5202 13.0438C21.5494 13.0146 21.5947 13 21.6563 13Z"
				fill="#190A28"
			/>
			<path
				d="M18.3932 16.5H16.1376C16.0761 16.5 16.0307 16.487 16.0015 16.4611C15.9756 16.4319 15.9626 16.3866 15.9626 16.325V13.175C15.9626 13.1134 15.9756 13.0697 16.0015 13.0438C16.0307 13.0146 16.0761 13 16.1376 13H18.3932C18.4548 13 18.4985 13.0146 18.5245 13.0438C18.5536 13.0697 18.5682 13.1134 18.5682 13.175V13.7437C18.5682 13.8053 18.5536 13.8507 18.5245 13.8799C18.4985 13.9058 18.4548 13.9187 18.3932 13.9187H17.0515V14.2931H17.9995C18.061 14.2931 18.1048 14.3076 18.1307 14.3368C18.1599 14.3627 18.1745 14.4065 18.1745 14.4681V14.9882C18.1745 15.0498 18.1599 15.0951 18.1307 15.1243C18.1048 15.1502 18.061 15.1632 17.9995 15.1632H17.0515V15.5813H18.3932C18.4548 15.5813 18.4985 15.5958 18.5245 15.625C18.5536 15.6509 18.5682 15.6947 18.5682 15.7562V16.325C18.5682 16.3866 18.5536 16.4319 18.5245 16.4611C18.4985 16.487 18.4548 16.5 18.3932 16.5Z"
				fill="#190A28"
			/>
			<path
				d="M13.2069 16.5H12.4777C12.4162 16.5 12.3708 16.487 12.3416 16.4611C12.3157 16.4319 12.3027 16.3866 12.3027 16.325V13.175C12.3027 13.1134 12.3157 13.0697 12.3416 13.0438C12.3708 13.0146 12.4162 13 12.4777 13H12.9833C13.0449 13 13.0967 13.0097 13.1388 13.0292C13.1842 13.0486 13.228 13.0826 13.2701 13.1313L14.2132 14.2104V13.175C14.2132 13.1134 14.2261 13.0697 14.252 13.0438C14.2812 13.0146 14.3266 13 14.3882 13H15.1173C15.1789 13 15.2226 13.0146 15.2486 13.0438C15.2777 13.0697 15.2923 13.1134 15.2923 13.175V16.325C15.2923 16.3866 15.2777 16.4319 15.2486 16.4611C15.2226 16.487 15.1789 16.5 15.1173 16.5H14.3882C14.3266 16.5 14.2812 16.487 14.252 16.4611C14.2261 16.4319 14.2132 16.3866 14.2132 16.325V15.7271L13.3819 14.7208V16.325C13.3819 16.3866 13.3673 16.4319 13.3382 16.4611C13.3122 16.487 13.2685 16.5 13.2069 16.5Z"
				fill="#190A28"
			/>
		</g>
		<defs>
			<clipPath id="clip0_20485_87466">
				<rect width={40} height={40} fill="white" />
			</clipPath>
		</defs>
	</svg>
);
const NewJobsTabSelectedDesktopIcon = () => (
	<svg
		width={40}
		height={40}
		viewBox="0 0 40 40"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g clipPath="url(#clip0_20351_814489)">
			<path
				d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
				fill="#D3BEF1"
			/>
			<rect
				x={9.5}
				y={9.97461}
				width={15.5501}
				height={19.9591}
				rx={0.882585}
				fill="#F1EAFA"
				stroke="#190A28"
				strokeWidth={0.933333}
			/>
			<path
				d="M11.8333 22.334H22.3333"
				stroke="#190A28"
				strokeWidth={1.16667}
				strokeLinecap="round"
			/>
			<path
				d="M11.8333 18.834H22.3333"
				stroke="#190A28"
				strokeWidth={1.16667}
				strokeLinecap="round"
			/>
			<path
				d="M11.8333 25.834H22.3333"
				stroke="#190A28"
				strokeWidth={1.16667}
				strokeLinecap="round"
			/>
			<rect
				x={20}
				y={25.6006}
				width={11.2}
				height={7.46667}
				rx={1.19399}
				fill="url(#paint0_linear_20351_814489)"
				stroke="#190A28"
				strokeWidth={0.933333}
			/>
			<path
				d="M20 25.7956C20 25.1728 20.5049 24.668 21.1277 24.668H30.0723C30.6951 24.668 31.2 25.1728 31.2 25.7956V28.2355C31.2 28.7088 30.9054 29.131 30.455 29.2766C29.3298 29.6404 27.1626 30.268 25.6 30.268C24.0374 30.268 21.8702 29.6404 20.745 29.2766C20.2946 29.131 20 28.7088 20 28.2355V25.7956Z"
				fill="url(#paint1_linear_20351_814489)"
				stroke="#190A28"
				strokeWidth={0.933333}
			/>
			<path
				d="M27.4667 24.6674V23.8721C27.4667 23.2804 26.9871 22.8008 26.3955 22.8008H24.8047C24.213 22.8008 23.7334 23.2804 23.7334 23.8721V24.6674"
				stroke="#190A28"
				strokeWidth={0.933333}
			/>
			<path
				d="M24.6667 29.5595C24.6667 29.435 24.7677 29.334 24.8923 29.334H26.3079C26.4324 29.334 26.5334 29.435 26.5334 29.5595V30.9751C26.5334 31.0997 26.4324 31.2007 26.3079 31.2007H24.8923C24.7677 31.2007 24.6667 31.0997 24.6667 30.9751V29.5595Z"
				fill="url(#paint2_linear_20351_814489)"
				stroke="#190A28"
				strokeWidth={0.933333}
			/>
			<g clipPath="url(#clip1_20351_814489)">
				<path
					d="M21.6563 13H22.3806C22.4422 13 22.4859 13.0146 22.5119 13.0438C22.541 13.0697 22.5556 13.1134 22.5556 13.175V15.0611C22.5556 15.1648 22.5508 15.262 22.541 15.3528C22.5346 15.4403 22.5102 15.544 22.4681 15.6639L22.2251 16.325C22.2089 16.3736 22.1846 16.4157 22.1521 16.4514C22.123 16.4838 22.0825 16.5 22.0306 16.5H21.3841C21.3322 16.5 21.2852 16.4887 21.2431 16.466C21.201 16.4433 21.1734 16.406 21.1605 16.3542L20.9369 15.5618C20.9271 15.5294 20.9142 15.5083 20.898 15.4986C20.885 15.4856 20.8688 15.4792 20.8494 15.4792H20.8056C20.7862 15.4792 20.7683 15.4856 20.7521 15.4986C20.7392 15.5083 20.7278 15.5294 20.7181 15.5618L20.4896 16.3542C20.4767 16.4028 20.4524 16.44 20.4167 16.466C20.3811 16.4887 20.3373 16.5 20.2855 16.5H19.6438C19.592 16.5 19.5466 16.4838 19.5077 16.4514C19.4721 16.419 19.4461 16.3769 19.4299 16.325L19.1869 15.6542C19.1447 15.5343 19.1188 15.4306 19.1091 15.3431C19.1026 15.2523 19.0994 15.1551 19.0994 15.0514V13.175C19.0994 13.1134 19.1123 13.0697 19.1383 13.0438C19.1674 13.0146 19.2128 13 19.2744 13H20.023C20.0846 13 20.1283 13.0146 20.1542 13.0438C20.1834 13.0697 20.198 13.1134 20.198 13.175V14.9639L20.4799 14.3514C20.5058 14.2963 20.5399 14.2574 20.582 14.2347C20.6241 14.212 20.676 14.2007 20.7376 14.2007H20.9417C21.0033 14.2007 21.0552 14.212 21.0973 14.2347C21.1394 14.2574 21.1734 14.2963 21.1994 14.3514L21.4813 14.9639V13.175C21.4813 13.1134 21.4943 13.0697 21.5202 13.0438C21.5494 13.0146 21.5947 13 21.6563 13Z"
					fill="#190A28"
				/>
				<path
					d="M18.3932 16.5H16.1376C16.0761 16.5 16.0307 16.487 16.0015 16.4611C15.9756 16.4319 15.9626 16.3866 15.9626 16.325V13.175C15.9626 13.1134 15.9756 13.0697 16.0015 13.0438C16.0307 13.0146 16.0761 13 16.1376 13H18.3932C18.4548 13 18.4985 13.0146 18.5245 13.0438C18.5536 13.0697 18.5682 13.1134 18.5682 13.175V13.7437C18.5682 13.8053 18.5536 13.8507 18.5245 13.8799C18.4985 13.9058 18.4548 13.9187 18.3932 13.9187H17.0515V14.2931H17.9995C18.061 14.2931 18.1048 14.3076 18.1307 14.3368C18.1599 14.3627 18.1745 14.4065 18.1745 14.4681V14.9882C18.1745 15.0498 18.1599 15.0951 18.1307 15.1243C18.1048 15.1502 18.061 15.1632 17.9995 15.1632H17.0515V15.5813H18.3932C18.4548 15.5813 18.4985 15.5958 18.5245 15.625C18.5536 15.6509 18.5682 15.6947 18.5682 15.7562V16.325C18.5682 16.3866 18.5536 16.4319 18.5245 16.4611C18.4985 16.487 18.4548 16.5 18.3932 16.5Z"
					fill="#190A28"
				/>
				<path
					d="M13.2069 16.5H12.4777C12.4162 16.5 12.3708 16.487 12.3416 16.4611C12.3157 16.4319 12.3027 16.3866 12.3027 16.325V13.175C12.3027 13.1134 12.3157 13.0697 12.3416 13.0438C12.3708 13.0146 12.4162 13 12.4777 13H12.9833C13.0449 13 13.0967 13.0097 13.1388 13.0292C13.1842 13.0486 13.228 13.0826 13.2701 13.1313L14.2132 14.2104V13.175C14.2132 13.1134 14.2261 13.0697 14.252 13.0438C14.2812 13.0146 14.3266 13 14.3882 13H15.1173C15.1789 13 15.2226 13.0146 15.2486 13.0438C15.2777 13.0697 15.2923 13.1134 15.2923 13.175V16.325C15.2923 16.3866 15.2777 16.4319 15.2486 16.4611C15.2226 16.487 15.1789 16.5 15.1173 16.5H14.3882C14.3266 16.5 14.2812 16.487 14.252 16.4611C14.2261 16.4319 14.2132 16.3866 14.2132 16.325V15.7271L13.3819 14.7208V16.325C13.3819 16.3866 13.3673 16.4319 13.3382 16.4611C13.3122 16.487 13.2685 16.5 13.2069 16.5Z"
					fill="#190A28"
				/>
			</g>
		</g>
		<defs>
			<linearGradient
				id="paint0_linear_20351_814489"
				x1={22.3333}
				y1={28.0895}
				x2={24.7172}
				y2={40.4423}
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#AC5DD9" />
				<stop offset={1} stopColor="#004FC4" />
			</linearGradient>
			<linearGradient
				id="paint1_linear_20351_814489"
				x1={22.3333}
				y1={26.5346}
				x2={23.6957}
				y2={35.9471}
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#AC5DD9" />
				<stop offset={1} stopColor="#004FC4" />
			</linearGradient>
			<linearGradient
				id="paint2_linear_20351_814489"
				x1={25.0556}
				y1={29.9562}
				x2={25.9112}
				y2={32.9118}
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#AC5DD9" />
				<stop offset={1} stopColor="#004FC4" />
			</linearGradient>
			<clipPath id="clip0_20351_814489">
				<rect width={40} height={40} fill="white" />
			</clipPath>
			<clipPath id="clip1_20351_814489">
				<rect
					width={10.2532}
					height={3.5}
					fill="white"
					transform="translate(12.3027 13)"
				/>
			</clipPath>
		</defs>
	</svg>
);
const NewJobsTabMobileIcon = () => (
	<svg
		width={48}
		height={48}
		viewBox="0 0 48 48"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M24 45C35.598 45 45 35.598 45 24C45 12.402 35.598 3 24 3C12.402 3 3 12.402 3 24C3 35.598 12.402 45 24 45Z"
			fill="#F1EAFA"
		/>
		<rect
			x={13.75}
			y={13.2573}
			width={16.6608}
			height={21.3848}
			rx={0.945627}
			fill="#F1EAFA"
			stroke="#190A28"
		/>
		<path
			d="M16.25 26.5H27.5"
			stroke="#190A28"
			strokeWidth={1.25}
			strokeLinecap="round"
		/>
		<path
			d="M16.25 22.75H27.5"
			stroke="#190A28"
			strokeWidth={1.25}
			strokeLinecap="round"
		/>
		<path
			d="M16.25 30.25H27.5"
			stroke="#190A28"
			strokeWidth={1.25}
			strokeLinecap="round"
		/>
		<rect
			x={25}
			y={30}
			width={12}
			height={8}
			rx={1.27928}
			fill="url(#paint0_linear_20485_87005)"
			stroke="#190A28"
		/>
		<path
			d="M25 30.2082C25 29.5409 25.5409 29 26.2082 29H35.7918C36.4591 29 37 29.5409 37 30.2082V32.8223C37 33.3294 36.6843 33.7818 36.2018 33.9378C34.9963 34.3276 32.6742 35 31 35C29.3258 35 27.0037 34.3276 25.7982 33.9378C25.3157 33.7818 25 33.3294 25 32.8223V30.2082Z"
			fill="url(#paint1_linear_20485_87005)"
			stroke="#190A28"
		/>
		<path
			d="M33 29V28.1478C33 27.5139 32.4861 27 31.8522 27H30.1478C29.5139 27 29 27.5139 29 28.1478V29"
			stroke="#190A28"
		/>
		<path
			d="M30 34.2416C30 34.1082 30.1082 34 30.2416 34H31.7584C31.8918 34 32 34.1082 32 34.2416V35.7584C32 35.8918 31.8918 36 31.7584 36H30.2416C30.1082 36 30 35.8918 30 35.7584V34.2416Z"
			fill="url(#paint2_linear_20485_87005)"
			stroke="#190A28"
		/>
		<path
			d="M26.7747 16.5H27.5508C27.6168 16.5 27.6636 16.5156 27.6914 16.5469C27.7227 16.5747 27.7383 16.6215 27.7383 16.6875V18.7083C27.7383 18.8194 27.7331 18.9236 27.7227 19.0208C27.7157 19.1146 27.6897 19.2257 27.6445 19.3542L27.3841 20.0625C27.3668 20.1146 27.3407 20.1597 27.306 20.1979C27.2747 20.2326 27.2313 20.25 27.1758 20.25H26.4831C26.4275 20.25 26.3772 20.2378 26.332 20.2135C26.2869 20.1892 26.2574 20.1493 26.2435 20.0938L26.0039 19.2448C25.9935 19.2101 25.9796 19.1875 25.9622 19.1771C25.9484 19.1632 25.931 19.1562 25.9102 19.1562H25.8633C25.8424 19.1562 25.8234 19.1632 25.806 19.1771C25.7921 19.1875 25.7799 19.2101 25.7695 19.2448L25.5247 20.0938C25.5109 20.1458 25.4848 20.1858 25.4466 20.2135C25.4084 20.2378 25.3615 20.25 25.306 20.25H24.6185C24.5629 20.25 24.5143 20.2326 24.4727 20.1979C24.4345 20.1632 24.4067 20.1181 24.3893 20.0625L24.1289 19.3438C24.0838 19.2153 24.056 19.1042 24.0456 19.0104C24.0386 18.9132 24.0352 18.809 24.0352 18.6979V16.6875C24.0352 16.6215 24.049 16.5747 24.0768 16.5469C24.1081 16.5156 24.1567 16.5 24.2227 16.5H25.0247C25.0907 16.5 25.1376 16.5156 25.1654 16.5469C25.1966 16.5747 25.2122 16.6215 25.2122 16.6875V18.6042L25.5143 17.9479C25.5421 17.8889 25.5786 17.8472 25.6237 17.8229C25.6688 17.7986 25.7244 17.7865 25.7904 17.7865H26.0091C26.0751 17.7865 26.1306 17.7986 26.1758 17.8229C26.2209 17.8472 26.2574 17.8889 26.2852 17.9479L26.5872 18.6042V16.6875C26.5872 16.6215 26.6011 16.5747 26.6289 16.5469C26.6602 16.5156 26.7088 16.5 26.7747 16.5Z"
			fill="#190A28"
		/>
		<path
			d="M23.279 20.25H20.8623C20.7963 20.25 20.7477 20.2361 20.7165 20.2083C20.6887 20.1771 20.6748 20.1285 20.6748 20.0625V16.6875C20.6748 16.6215 20.6887 16.5747 20.7165 16.5469C20.7477 16.5156 20.7963 16.5 20.8623 16.5H23.279C23.3449 16.5 23.3918 16.5156 23.4196 16.5469C23.4508 16.5747 23.4665 16.6215 23.4665 16.6875V17.2969C23.4665 17.3628 23.4508 17.4115 23.4196 17.4427C23.3918 17.4705 23.3449 17.4844 23.279 17.4844H21.8415V17.8854H22.8571C22.9231 17.8854 22.9699 17.901 22.9977 17.9323C23.029 17.9601 23.0446 18.0069 23.0446 18.0729V18.6302C23.0446 18.6962 23.029 18.7448 22.9977 18.776C22.9699 18.8038 22.9231 18.8177 22.8571 18.8177H21.8415V19.2656H23.279C23.3449 19.2656 23.3918 19.2812 23.4196 19.3125C23.4508 19.3403 23.4665 19.3872 23.4665 19.4531V20.0625C23.4665 20.1285 23.4508 20.1771 23.4196 20.2083C23.3918 20.2361 23.3449 20.25 23.279 20.25Z"
			fill="#190A28"
		/>
		<path
			d="M17.7217 20.25H16.9404C16.8745 20.25 16.8258 20.2361 16.7946 20.2083C16.7668 20.1771 16.7529 20.1285 16.7529 20.0625V16.6875C16.7529 16.6215 16.7668 16.5747 16.7946 16.5469C16.8258 16.5156 16.8745 16.5 16.9404 16.5H17.4821C17.5481 16.5 17.6036 16.5104 17.6488 16.5312C17.6974 16.5521 17.7442 16.5885 17.7894 16.6406L18.7998 17.7969V16.6875C18.7998 16.6215 18.8137 16.5747 18.8415 16.5469C18.8727 16.5156 18.9213 16.5 18.9873 16.5H19.7686C19.8345 16.5 19.8814 16.5156 19.9092 16.5469C19.9404 16.5747 19.9561 16.6215 19.9561 16.6875V20.0625C19.9561 20.1285 19.9404 20.1771 19.9092 20.2083C19.8814 20.2361 19.8345 20.25 19.7686 20.25H18.9873C18.9213 20.25 18.8727 20.2361 18.8415 20.2083C18.8137 20.1771 18.7998 20.1285 18.7998 20.0625V19.4219L17.9092 18.3438V20.0625C17.9092 20.1285 17.8936 20.1771 17.8623 20.2083C17.8345 20.2361 17.7877 20.25 17.7217 20.25Z"
			fill="#190A28"
		/>
		<defs>
			<linearGradient
				id="paint0_linear_20485_87005"
				x1={27.5}
				y1={32.6667}
				x2={30.0542}
				y2={45.9018}
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#AC5DD9" />
				<stop offset={1} stopColor="#004FC4" />
			</linearGradient>
			<linearGradient
				id="paint1_linear_20485_87005"
				x1={27.5}
				y1={31}
				x2={28.9596}
				y2={41.0848}
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#AC5DD9" />
				<stop offset={1} stopColor="#004FC4" />
			</linearGradient>
			<linearGradient
				id="paint2_linear_20485_87005"
				x1={30.4167}
				y1={34.6667}
				x2={31.3333}
				y2={37.8333}
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#AC5DD9" />
				<stop offset={1} stopColor="#004FC4" />
			</linearGradient>
		</defs>
	</svg>
);
const NewJobsTabSelectedMobileIcon = () => (
	<svg
		width={48}
		height={48}
		viewBox="0 0 48 48"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M44.5 24C44.5 35.3218 35.3218 44.5 24 44.5C12.6782 44.5 3.5 35.3218 3.5 24C3.5 12.6782 12.6782 3.5 24 3.5C35.3218 3.5 44.5 12.6782 44.5 24Z"
			fill="#F1EAFA"
			stroke="#722ED1"
		/>
		<rect
			x={13.75}
			y={13.2573}
			width={16.6608}
			height={21.3848}
			rx={0.945627}
			fill="#F1EAFA"
			stroke="#190A28"
		/>
		<path
			d="M16.25 26.5H27.5"
			stroke="#190A28"
			strokeWidth={1.25}
			strokeLinecap="round"
		/>
		<path
			d="M16.25 22.75H27.5"
			stroke="#190A28"
			strokeWidth={1.25}
			strokeLinecap="round"
		/>
		<path
			d="M16.25 30.25H27.5"
			stroke="#190A28"
			strokeWidth={1.25}
			strokeLinecap="round"
		/>
		<rect
			x={25}
			y={30}
			width={12}
			height={8}
			rx={1.27928}
			fill="url(#paint0_linear_20485_87146)"
			stroke="#190A28"
		/>
		<path
			d="M25 30.2082C25 29.5409 25.5409 29 26.2082 29H35.7918C36.4591 29 37 29.5409 37 30.2082V32.8223C37 33.3294 36.6843 33.7818 36.2018 33.9378C34.9963 34.3276 32.6742 35 31 35C29.3258 35 27.0037 34.3276 25.7982 33.9378C25.3157 33.7818 25 33.3294 25 32.8223V30.2082Z"
			fill="url(#paint1_linear_20485_87146)"
			stroke="#190A28"
		/>
		<path
			d="M33 29V28.1478C33 27.5139 32.4861 27 31.8522 27H30.1478C29.5139 27 29 27.5139 29 28.1478V29"
			stroke="#190A28"
		/>
		<path
			d="M30 34.2416C30 34.1082 30.1082 34 30.2416 34H31.7584C31.8918 34 32 34.1082 32 34.2416V35.7584C32 35.8918 31.8918 36 31.7584 36H30.2416C30.1082 36 30 35.8918 30 35.7584V34.2416Z"
			fill="url(#paint2_linear_20485_87146)"
			stroke="#190A28"
		/>
		<path
			d="M26.7747 16.5H27.5508C27.6168 16.5 27.6636 16.5156 27.6914 16.5469C27.7227 16.5747 27.7383 16.6215 27.7383 16.6875V18.7083C27.7383 18.8194 27.7331 18.9236 27.7227 19.0208C27.7157 19.1146 27.6897 19.2257 27.6445 19.3542L27.3841 20.0625C27.3668 20.1146 27.3407 20.1597 27.306 20.1979C27.2747 20.2326 27.2313 20.25 27.1758 20.25H26.4831C26.4275 20.25 26.3772 20.2378 26.332 20.2135C26.2869 20.1892 26.2574 20.1493 26.2435 20.0938L26.0039 19.2448C25.9935 19.2101 25.9796 19.1875 25.9622 19.1771C25.9484 19.1632 25.931 19.1562 25.9102 19.1562H25.8633C25.8424 19.1562 25.8234 19.1632 25.806 19.1771C25.7921 19.1875 25.7799 19.2101 25.7695 19.2448L25.5247 20.0938C25.5109 20.1458 25.4848 20.1858 25.4466 20.2135C25.4084 20.2378 25.3615 20.25 25.306 20.25H24.6185C24.5629 20.25 24.5143 20.2326 24.4727 20.1979C24.4345 20.1632 24.4067 20.1181 24.3893 20.0625L24.1289 19.3438C24.0838 19.2153 24.056 19.1042 24.0456 19.0104C24.0386 18.9132 24.0352 18.809 24.0352 18.6979V16.6875C24.0352 16.6215 24.049 16.5747 24.0768 16.5469C24.1081 16.5156 24.1567 16.5 24.2227 16.5H25.0247C25.0907 16.5 25.1376 16.5156 25.1654 16.5469C25.1966 16.5747 25.2122 16.6215 25.2122 16.6875V18.6042L25.5143 17.9479C25.5421 17.8889 25.5786 17.8472 25.6237 17.8229C25.6688 17.7986 25.7244 17.7865 25.7904 17.7865H26.0091C26.0751 17.7865 26.1306 17.7986 26.1758 17.8229C26.2209 17.8472 26.2574 17.8889 26.2852 17.9479L26.5872 18.6042V16.6875C26.5872 16.6215 26.6011 16.5747 26.6289 16.5469C26.6602 16.5156 26.7088 16.5 26.7747 16.5Z"
			fill="#190A28"
		/>
		<path
			d="M23.279 20.25H20.8623C20.7963 20.25 20.7477 20.2361 20.7165 20.2083C20.6887 20.1771 20.6748 20.1285 20.6748 20.0625V16.6875C20.6748 16.6215 20.6887 16.5747 20.7165 16.5469C20.7477 16.5156 20.7963 16.5 20.8623 16.5H23.279C23.3449 16.5 23.3918 16.5156 23.4196 16.5469C23.4508 16.5747 23.4665 16.6215 23.4665 16.6875V17.2969C23.4665 17.3628 23.4508 17.4115 23.4196 17.4427C23.3918 17.4705 23.3449 17.4844 23.279 17.4844H21.8415V17.8854H22.8571C22.9231 17.8854 22.9699 17.901 22.9977 17.9323C23.029 17.9601 23.0446 18.0069 23.0446 18.0729V18.6302C23.0446 18.6962 23.029 18.7448 22.9977 18.776C22.9699 18.8038 22.9231 18.8177 22.8571 18.8177H21.8415V19.2656H23.279C23.3449 19.2656 23.3918 19.2812 23.4196 19.3125C23.4508 19.3403 23.4665 19.3872 23.4665 19.4531V20.0625C23.4665 20.1285 23.4508 20.1771 23.4196 20.2083C23.3918 20.2361 23.3449 20.25 23.279 20.25Z"
			fill="#190A28"
		/>
		<path
			d="M17.7217 20.25H16.9404C16.8745 20.25 16.8258 20.2361 16.7946 20.2083C16.7668 20.1771 16.7529 20.1285 16.7529 20.0625V16.6875C16.7529 16.6215 16.7668 16.5747 16.7946 16.5469C16.8258 16.5156 16.8745 16.5 16.9404 16.5H17.4821C17.5481 16.5 17.6036 16.5104 17.6488 16.5312C17.6974 16.5521 17.7442 16.5885 17.7894 16.6406L18.7998 17.7969V16.6875C18.7998 16.6215 18.8137 16.5747 18.8415 16.5469C18.8727 16.5156 18.9213 16.5 18.9873 16.5H19.7686C19.8345 16.5 19.8814 16.5156 19.9092 16.5469C19.9404 16.5747 19.9561 16.6215 19.9561 16.6875V20.0625C19.9561 20.1285 19.9404 20.1771 19.9092 20.2083C19.8814 20.2361 19.8345 20.25 19.7686 20.25H18.9873C18.9213 20.25 18.8727 20.2361 18.8415 20.2083C18.8137 20.1771 18.7998 20.1285 18.7998 20.0625V19.4219L17.9092 18.3438V20.0625C17.9092 20.1285 17.8936 20.1771 17.8623 20.2083C17.8345 20.2361 17.7877 20.25 17.7217 20.25Z"
			fill="#190A28"
		/>
		<defs>
			<linearGradient
				id="paint0_linear_20485_87146"
				x1={27.5}
				y1={32.6667}
				x2={30.0542}
				y2={45.9018}
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#AC5DD9" />
				<stop offset={1} stopColor="#004FC4" />
			</linearGradient>
			<linearGradient
				id="paint1_linear_20485_87146"
				x1={27.5}
				y1={31}
				x2={28.9596}
				y2={41.0848}
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#AC5DD9" />
				<stop offset={1} stopColor="#004FC4" />
			</linearGradient>
			<linearGradient
				id="paint2_linear_20485_87146"
				x1={30.4167}
				y1={34.6667}
				x2={31.3333}
				y2={37.8333}
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#AC5DD9" />
				<stop offset={1} stopColor="#004FC4" />
			</linearGradient>
		</defs>
	</svg>
);

const NewJobsTabIcon = {
	mobile: <NewJobsTabMobileIcon />,
	mobileSelected: <NewJobsTabSelectedMobileIcon />,
	desktop: <NewJobsTabDesktopIcon />,
	desktopSelected: <NewJobsTabSelectedDesktopIcon />,
};

export default NewJobsTabIcon;
